import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {Alert, Button, message, Modal, Space, Table} from "antd";
import DOMPurify from 'dompurify';
import { apiGet, parseJsonResponse } from "../api/apiClient";
import { createAuftragExecute } from "../api/auftrag";
import Sidebar from "../components/sidebar";
import useScreenSize from "../hooks/useScreenSize";
import { useSwitch } from "../pages/SwitchContext";
import {MdContentCopy, MdEdit} from "react-icons/md";
import { Link } from "react-router-dom";
import icon1 from '../../src/assets/icon1.png'
import icon2 from '../../src/assets/icon2.png'
import icon3 from '../../src/assets/icon3.png'
import icon4 from '../../src/assets/icon4.png'
import icon5 from '../../src/assets/icon5.png'
import icon6 from '../../src/assets/icon6.png'
import { useAuthContext } from "../context/AuthContext";


const sideOptions = [
    {
        value: "Auftrag",
        icon: icon1
    },
    {
        value: "Ortstermin",
        icon: icon2
    },
    {
        value: "Unterlagen",
        icon: icon3
    },
    {
        value: "Bearbeitung",
        icon: icon4
    },
    {
        value: "fertiggestellt",
        icon: icon5
    },
    {
        value: "storniert",
        icon: icon6
    },
];


const AuftragUebersicht = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [vis, setVis] = useState(false);
    const { isDesktopView } = useScreenSize();
    const { isSwitchOn, toggleSwitch } = useSwitch();
    const [currentDate, setCurrentDate] = useState(new Date());
    const [orderThisMonth, setOrderThisMonth] = useState(false);
    const [search, setSearch] = useState("");
    const [tableData, setTableData] = useState([])
    const [selected, setSelected] = useState("")
    const { user, konfiguration: userKonfiguration } = useAuthContext();
    const navigate = useNavigate();

    const tableBewertungsObjekteOutput = (gutachten) => {
        let currentBewertungsobjekteValue = "";
        // Defensive Defaults: bei externen Usern oder unvollständigem Populate
        // können Zwischen-Components fehlen. Ohne Guard crasht die ganze Tabelle.
        const detail = gutachten?.AllgAng?.AllgAng_Detail ?? {};
        if (detail.ObjektartV) {
            currentBewertungsobjekteValue += detail.ObjektartV + ", ";
        }
        if (detail.Strasse) {
            currentBewertungsobjekteValue += detail.Strasse + ", ";
        }
        if (detail.NrZusatz) {
            currentBewertungsobjekteValue += detail.NrZusatz + ", ";
        }
        if (detail.PLZ) {
            currentBewertungsobjekteValue += detail.PLZ + ", ";
        }
        if (detail.Ort) {
            currentBewertungsobjekteValue += detail.Ort;
        }
        const bewertungsobjekts = gutachten?.bewertungsobjekts ?? [];
        bewertungsobjekts.forEach(bewertungsobjekte => {
            if (bewertungsobjekte?.Name_BO) {
                currentBewertungsobjekteValue += "<br/>" + bewertungsobjekte.Name_BO;
            }
        });
        return currentBewertungsobjekteValue;
    }

    const fetchKontakte = async () => {
        setIsLoading(true);

        try {
            const response = await apiGet('/helper/acl/auftrag/?populate=deep&sort=createdAt:desc');
            const dataContainer = await parseJsonResponse(response);

            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth();
            // Filter items based on the createdAt property
            const filteredItems = dataContainer.filter((item) => {
                // Assuming createdAt is a timestamp; adjust this based on your data structure
                const createdAtDate = new Date(item?.createdAt);

                const itemYear = createdAtDate.getFullYear();
                const itemMonth = createdAtDate.getMonth() ;

                // Check if the item's year and month match the current year and month
                return itemYear === currentYear && itemMonth === currentMonth;
            });
            setOrderThisMonth(filteredItems.length);

            let tableDatad = dataContainer.map((item, index) => {
                let bewertungsobjekteOutput = "";
                (item?.gutachtens ?? []).forEach(gutachten => {
                    if(bewertungsobjekteOutput != "" && tableBewertungsObjekteOutput(gutachten) != "") {
                        bewertungsobjekteOutput += "<br/><br/>";
                    }
                    bewertungsobjekteOutput += tableBewertungsObjekteOutput(gutachten);
                });
                return {
                    key: index,
                    id: item.id,
                    Auftragsnummer: item.Auftragsnummer,
                    Jahr: item.Jahr,
                    Auftrag_StatusV: item.Auftrag_StatusV,
                    AuftragsartV: item.AuftragsartV,
                    bewertungsobjekte: bewertungsobjekteOutput,
                };
            });
            setTableData(tableDatad)

        } catch (error) {
            console.error('[AuftragUebersicht] fetchKontakte:', error);
            message.error(`Fehler beim Laden der Aufträge: ${error?.message ?? 'unbekannter Fehler'}`);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (search !== "" || selected !== "") {
            Search();

        } else if(userKonfiguration !== undefined) {
            fetchKontakte().then();
        }
    }, [search, selected, userKonfiguration]);
    useEffect(() => {
        if (isDesktopView) {
            setVis(true);
        } else {
            setVis(false);
        }


    }, [isDesktopView]);
    const Search = () => {
        const path = `/helper/acl/auftrag?sort[0]=id:desc&populate=deep&filters[$or][0][Auftragsnummer][$contains]=${selected ? selected : search}&filters[$or][1][Auftrag_StatusV][$eq]=${selected ? selected : search}`;
        apiGet(path)
            .then((res) => parseJsonResponse(res))
            .then(data => {
                setTableData(data?.map((item, index) => {
                    let bewertungsobjekteOutput = "";
                    (item?.gutachtens ?? []).forEach(gutachten => {
                        if (bewertungsobjekteOutput !== "" && tableBewertungsObjekteOutput(gutachten) !== "") {
                            bewertungsobjekteOutput += "<br/><br/>";
                        }
                        bewertungsobjekteOutput += tableBewertungsObjekteOutput(gutachten);
                    });
                    return {
                        key: index,
                        id: item.id,
                        Auftragsnummer: item.Auftragsnummer,
                        Jahr: item.Jahr,
                        Auftrag_StatusV: item.Auftrag_StatusV,
                        AuftragsartV: item.AuftragsartV,
                        bewertungsobjekte: bewertungsobjekteOutput,
                    };
                }));
            })
            .catch(err => console.error(err));
    };

    // Modal for creating a new Auftrag
    const createAuftrag = () => {
        const confirmContent = (
            <div>
                Möchten Sie einen neuen Auftrag erstellen? <br/><br/>
                <Alert
                    description={<span>Diesen Monat bereits erstellte Aufträge: <b>{orderThisMonth}</b></span>}
                    type="info"
                    showIcon
                />
            </div>
        );
        Modal.confirm({
            title: "Auftrag erstellen",
            content: confirmContent,
            onOk: () => {
                createAuftragExecute(userKonfiguration, navigate, 0).then();
            },
            onCancel() {
                console.log("Erstellen abgebrochen");
            },
        });
    }

    // Modal for duplicating a Auftrag
    const duplicateAuftrag = (duplicateID) => {
        const confirmContent = (
            <div>
                Möchten Sie diesen Auftrag duplizieren? <br /><br /> Alle Daten (außer hochgeladene Dokumente) werden kopiert und können bearbeitet werden.<br/><br/>
                <Alert
                    description={<span>Diesen Monat bereits erstellte Aufträge: <b>{orderThisMonth}</b></span>}
                    type="info"
                    showIcon
                />
            </div>
        );
        Modal.confirm({
            title: "Auftrag duplizieren",
            content: confirmContent,
            onOk: () => {
                createAuftragExecute(userKonfiguration, navigate, duplicateID).then();
            },
            onCancel() {
                console.log("Erstellen abgebrochen");
            },
        });
    }



    const columns = [
        {
            title: "Auftrag",
            dataIndex: "Auftragsnummer",
            key: "Auftragsnummer",
        },
        {
            title: "Auftragsart",
            dataIndex: "AuftragsartV",
            key: "AuftragsartV",
        },
        {
            title: "Status",
            dataIndex: "Auftrag_StatusV",
            key: "Auftrag_StatusV",
            render: (text, record) => {
                let backgroundColor;
                let textColor;

                switch (text) {
                    case "Auftrag":
                        backgroundColor = "grey";
                        textColor = "white";
                        break;
                    case "Ortstermin":
                        backgroundColor = "yellow";
                        textColor = "#9d9d5e";
                        break;
                    case "Unterlagen":
                        backgroundColor = "purple";
                        textColor = "white";
                        break;
                    case "Bearbeitung":
                        backgroundColor = "#B5E0FF";
                        textColor = "#28A5FF";
                        break;
                    case "fertiggestellt":
                        backgroundColor = "#96bf96";
                        textColor = "#358325";
                        break;
                    case "storniert":
                        backgroundColor = "#FFB5B5";
                        textColor = "#FF2828";
                        break;
                    default:
                        backgroundColor = "transparent";
                        textColor = "black"; // Default text color
                }

                return (
                    <div style={{ backgroundColor, color: textColor }} className="audtragStuBack">
                        {text}
                    </div>
                );
            },
        },
        {
            title: "Bewertungsobjekte",
            dataIndex: "bewertungsobjekte",
            key: "bewertungsobjekte",
            render: function(html) {
                const safe = DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true } });
                return <div dangerouslySetInnerHTML={{ __html: safe }} />;
            }
        },

        {
            title: "",
            key: "actions",
            render: (text, record) => (
                <Space size="middle">
                    {user && !user.extern && (
                    <Link onClick={() => duplicateAuftrag(record.id)} >
                        <MdContentCopy className={`text-[22px] ${isSwitchOn ? 'textwhite' : 'text-black'} mb-[5px] mr-[-10px] text-[#FF2E3B]`} />
                    </Link>
                    )}
                    <Link to={`/auftrag/${record.id}`}>
                        <MdEdit className={`text-[22px] ${isSwitchOn ? 'textwhite' : 'text-black'} mb-[5px] mr-[-10px] text-[#FF2E3B]`} />
                    </Link>
                </Space>
            ),
        },
    ];



    const handleVisibilityChange = (newVisibility) => {
        setVis(newVisibility);
    };

    return (
        <div className="w-full">

            <div
                className={`flex flex-row gap-[30px]  mr-[40px]  mb-[80px] ${!isDesktopView ? "ml-[40px]" : ""
                    }`}
            >
                {vis ? (
                    <Sidebar
                        sideOptions={sideOptions}
                        handleCreate={createAuftrag}
                        head="Auftrag erstellen"
                        pageTittle="Aufträge"
                        selected={selected}
                        setSelected={setSelected}
                        vis={vis}
                        onVisibilityChange={handleVisibilityChange}
                    />
                ) : (
                    ""
                )}
                <div
                    style={{ overflowX: "hidden" }}
                    className="rounded-[30px]   w-full"
                >
                    {" "}
                    <div
                        className={` relative w-[80%] sm:w-[489px] h-[54px]   ${isSwitchOn ? "bg-black" : "bg-white"
                            } flex justify-between rounded-[30px] shadow px-[20px] items-center mb-[17px]`}
                    >
                        <img src={require("../assets/search.png")} className=" " alt="" />
                        <input
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setSelected("")
                            }}
                            type="text"
                            className={` w-[100%] h-full text-neutral-700 ${isSwitchOn ? "text-white" : "text-neutral-700"
                                } focus:border-none outline-none shadow-none rounded pl-[10px] ${isSwitchOn ? "bgdark" : "bgwhite"
                                }`}
                            placeholder="Suchen..."
                        />
                    </div>
                    <div
                        className={`${!isDesktopView ? "visible  cursor-pointer" : "hidden"
                            } text-white `}
                        onClick={() => {
                            setVis(!vis);
                        }}
                    >
                        <button className="menuBtn">Menu</button>
                    </div>
                    <Table
                        rowKey="id"
                        columns={columns}
                        dataSource={tableData}
                        responsive
                        pagination={{
                            pageSizeOptions: [20, 50, 100, 150],
                            defaultPageSize: 20,
                            locale: {items_per_page: "Einträge / Seite"}
                        }}
                        style={{
                            background: "white",
                            overflowX: "auto",
                            borderRadius: "30px",

                        }}
                    className={`  ${isSwitchOn ? 'bgdark' : 'bgwhite'} tableauftrag  ${isSwitchOn ? 'tableComtainer' : 'tableComtainerBlack'}`}
                    />
                </div>
            </div>{" "}
        </div>
    );
};

export default AuftragUebersicht;
